<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('documents')"
      :columns="columns"
      :column_search="true"
      :extra_data="{ patient_uuid: $route.params.patient_uuid }"
      resource_url="/patient/document/datatables"
      :is_container="false"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>

    <document-modal ref="document_modal" @success="refresh" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import DocumentModal from "../../document_modal/Index.vue";

import {
  get,
  error_message,
  format_date_time,
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
} from "@/utils";

export default {
  name: "Documents",
  components: { GenericTable, DocumentModal },
  data() {
    let v = this;
    return {
      appointments: [],
      columns: [
        {
          title: v.$t("date"),
          searchable: true,
          // width: "60%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_date_time(row.start_date);
          },
        },
        {
          title: v.$t("name"),
          name: "name",
          searchable: true,
          // width: "60%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.name || "";
          },
        },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("view"),
                icon: "fa fa-eye",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.document_modal.edit(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete document?"),
                    v,
                    () => {
                      del("/patient/document", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_date_time,
    refresh() {
      let v = this;
      // Lógica para obtener las citas del paciente
      // get("/patient/appointment/list", { uuid: v.$route.params.patient_uuid })
      //   .then((appointments) => {
      //     v.appointments = appointments;
      //   })
      //   .catch((error) => {
      //     error_message(error);
      // });

      v.$refs.datatable.refresh();
    },
    create() {
      let v = this;
      v.$refs.document_modal.create({
        date: new Date(),
      });
    },
  },
};
</script>

<style scoped>
.container {
  margin-top: 20px;
}
</style>
